import { CreateAccountModal } from '@app/components/accounts/CreateAccount/CreateAccountModal';
import { useAccountRequestDetails } from '@app/services/hooks/account/useAccountRequestDetails';
import { useLookbookWishlistProducts } from '@app/services/hooks/lookbook/useLookbookWishlistProducts';

import { CreateAccountFormValue } from './CreateAccountFormContent';
interface Props {
  onSuccess: () => void;
  isOpen: boolean;
  onClose: VoidFunction;
  createSource?: 'lookbook';
  accountRequestId?: string;
}

export const CreateAccountFromRequestModal = ({ accountRequestId, onSuccess, isOpen, onClose, createSource }: Props) => {
  const { data: accountRequestDetails, isLoading: isLoadingAccountRequestDetails } = useAccountRequestDetails({ id: accountRequestId });
  const accountRequsetLookbook = accountRequestDetails?.source?.lookbook;
  const accountRequsetWishlist = accountRequestDetails?.source?.wishlist;
  const {
    wishlist,
    deliveryWindows,
    isLoading: isLoadingWishlistProducts,
  } = useLookbookWishlistProducts({ lookbookId: accountRequsetLookbook, wishlistId: accountRequsetWishlist });

  const formDefaultValues: CreateAccountFormValue = {
    accountName: accountRequestDetails?.company ?? '',
    address: accountRequestDetails?.address ?? '',
    address2: accountRequestDetails?.address2 ?? '',
    city: accountRequestDetails?.city ?? '',
    country: accountRequestDetails?.country ?? '',
    email: accountRequestDetails?.email ?? '',
    firstName: accountRequestDetails?.firstName ?? '',
    lastName: accountRequestDetails?.lastName ?? '',
    market: accountRequestDetails?.source?.market?.toString() ?? '',
    paymentTerm: null,
    pricelist: null,
    salesRep: null,
    shippingTerm: null,
    state: accountRequestDetails?.state ?? '',
    zipCode: accountRequestDetails?.zipcode ?? '',
  };

  return (
    <CreateAccountModal
      onSuccess={onSuccess}
      onClose={onClose}
      isOpen={isOpen}
      createSource={createSource}
      shouldCreateSelection
      products={wishlist}
      accountRequestId={accountRequestId}
      deliveryWindows={deliveryWindows}
      formDefaultValues={formDefaultValues}
      isLoading={isLoadingAccountRequestDetails || isLoadingWishlistProducts}
    />
  );
};
